import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FaqSection.css';

const faqItems = [
  {
    id: 1,
    question: 'What types of CNC and industrial machines do you offer?',
    answer: 'DEXA Innovation offers a range of CNC and industrial machinery for different manufacturing and production requirements. Explore our product categories to find the right solution for your business.'
  },
  {
    id: 2,
    question: 'How do I choose the right machine for my requirements?',
    answer: 'Our team can understand your production requirements, material, application, capacity, and workflow to help you identify the most suitable machine.'
  },
  {
    id: 3,
    question: 'Do you provide machine installation and operator training?',
    answer: 'Yes. We provide installation support and operator guidance to help customers get started with their machinery smoothly and confidently.'
  },
  {
    id: 4,
    question: 'Do you provide after-sales service and spare parts?',
    answer: 'Yes. DEXA provides after-sales technical support and assistance with maintenance and genuine spare parts, subject to the machine and service requirements.'
  },
  {
    id: 5,
    question: 'How can I request a quotation?',
    answer: 'Simply contact DEXA through the Get a Quote button or contact form. Share your machine requirements, and our team will get back to you with the relevant details.'
  }
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faq">
      <div className="faq-container">
        
        {/* Left Column - Headline & CTA */}
        <div className="faq-left-col">
          <span className="faq-tag">FAQ</span>
          <h2 className="faq-title">
           Everything You Need to Know Before You Buy
          </h2>
          <p className="faq-desc">
Get answers to common questions about our CNC and industrial machinery, installation, training, and after-sales support.          </p>

          <Link to="/contact" className="faq-quote-btn">
            <span>Get a Quote</span>
            <span className="faq-btn-arrow">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
              </svg>
            </span>
          </Link>
        </div>

        {/* Right Column - Accordion List */}
        <div className="faq-right-col">
          <div className="faq-accordion-box">
            {faqItems.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.id} className={`faq-item ${isOpen ? 'open' : ''}`}>
                  <button 
                    className="faq-question-btn" 
                    onClick={() => toggleFaq(index)}
                    aria-expanded={isOpen}
                  >
                    <span>{item.question}</span>
                    <span className="faq-toggle-icon">
                      {isOpen ? (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                      ) : (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                      )}
                    </span>
                  </button>

                  {isOpen && (
                    <div className="faq-answer-body">
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
  );
};

export default FaqSection;
